import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegacyPointFeedPreBake = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7385 52.5L32.3385 28.5H67.6615L77.2615 52.5H22.7385Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_415_307",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M19 52H81V81H19V52Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 52H81V81H19V52Z",
			fill: "#E8F4F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81 81V82H82V81H81ZM19 81H18V82H19V81ZM80 52V81H82V52H80ZM81 80H19V82H81V80ZM20 81V52H18V81H20Z",
			fill: "currentColor",
			mask: "url(#path-2-inside-1_415_307)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.5,
			y: 58.5,
			width: 45,
			height: 5,
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25 69H75V63H25V69ZM73.2929 64L74 64.7071V66.2929L71.7071 64H73.2929ZM26 67.7071L26.2929 68H26V67.7071ZM26 66.2929L27.7071 68H29.2929L26 64.7071V66.2929ZM28.2929 64L32.2929 68H30.7071L26.7071 64H28.2929ZM33.7071 68L29.7071 64H31.2929L35.2929 68H33.7071ZM36.7071 68L32.7071 64H34.2929L38.2929 68H36.7071ZM39.7071 68L35.7071 64H37.2929L41.2929 68H39.7071ZM42.7071 68L38.7071 64H40.2929L44.2929 68H42.7071ZM45.7071 68L41.7071 64H43.2929L47.2929 68H45.7071ZM48.7071 68L44.7071 64H46.2929L50.2929 68H48.7071ZM51.7071 68L47.7071 64H49.2929L53.2929 68H51.7071ZM54.7071 68L50.7071 64H52.2929L56.2929 68H54.7071ZM57.7071 68L53.7071 64H55.2929L59.2929 68H57.7071ZM60.7071 68L56.7071 64H58.2929L62.2929 68H60.7071ZM63.7071 68L59.7071 64H61.2929L65.2929 68H63.7071ZM66.7071 68L62.7071 64H64.2929L68.2929 68H66.7071ZM69.7071 68L65.7071 64H67.2929L71.2929 68H69.7071ZM72.7071 68L68.7071 64H70.2929L74 67.7071V68H72.7071Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.5,
			y: 68.5,
			width: 71,
			height: 3,
			rx: 1.5,
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 72H79V79H21V72ZM26 75C26.5523 75 27 74.5523 27 74C27 73.4477 26.5523 73 26 73C25.4477 73 25 73.4477 25 74C25 74.5523 25.4477 75 26 75ZM25 75.5C25 76.0523 24.5523 76.5 24 76.5C23.4477 76.5 23 76.0523 23 75.5C23 74.9477 23.4477 74.5 24 74.5C24.5523 74.5 25 74.9477 25 75.5ZM29 75.5C29 76.0523 28.5523 76.5 28 76.5C27.4477 76.5 27 76.0523 27 75.5C27 74.9477 27.4477 74.5 28 74.5C28.5523 74.5 29 74.9477 29 75.5ZM27 77C27 77.5523 26.5523 78 26 78C25.4477 78 25 77.5523 25 77C25 76.4477 25.4477 76 26 76C26.5523 76 27 76.4477 27 77ZM30 75C30.5523 75 31 74.5523 31 74C31 73.4477 30.5523 73 30 73C29.4477 73 29 73.4477 29 74C29 74.5523 29.4477 75 30 75ZM33 75.5C33 76.0523 32.5523 76.5 32 76.5C31.4477 76.5 31 76.0523 31 75.5C31 74.9477 31.4477 74.5 32 74.5C32.5523 74.5 33 74.9477 33 75.5ZM36 76.5C36.5523 76.5 37 76.0523 37 75.5C37 74.9477 36.5523 74.5 36 74.5C35.4477 74.5 35 74.9477 35 75.5C35 76.0523 35.4477 76.5 36 76.5ZM31 77C31 77.5523 30.5523 78 30 78C29.4477 78 29 77.5523 29 77C29 76.4477 29.4477 76 30 76C30.5523 76 31 76.4477 31 77ZM34 75C34.5523 75 35 74.5523 35 74C35 73.4477 34.5523 73 34 73C33.4477 73 33 73.4477 33 74C33 74.5523 33.4477 75 34 75ZM35 77C35 77.5523 34.5523 78 34 78C33.4477 78 33 77.5523 33 77C33 76.4477 33.4477 76 34 76C34.5523 76 35 76.4477 35 77ZM38 75C38.5523 75 39 74.5523 39 74C39 73.4477 38.5523 73 38 73C37.4477 73 37 73.4477 37 74C37 74.5523 37.4477 75 38 75ZM55 74C55 74.5523 54.5523 75 54 75C53.4477 75 53 74.5523 53 74C53 73.4477 53.4477 73 54 73C54.5523 73 55 73.4477 55 74ZM70 75C70.5523 75 71 74.5523 71 74C71 73.4477 70.5523 73 70 73C69.4477 73 69 73.4477 69 74C69 74.5523 69.4477 75 70 75ZM41 75.5C41 76.0523 40.5523 76.5 40 76.5C39.4477 76.5 39 76.0523 39 75.5C39 74.9477 39.4477 74.5 40 74.5C40.5523 74.5 41 74.9477 41 75.5ZM56 76.5C56.5523 76.5 57 76.0523 57 75.5C57 74.9477 56.5523 74.5 56 74.5C55.4477 74.5 55 74.9477 55 75.5C55 76.0523 55.4477 76.5 56 76.5ZM73 75.5C73 76.0523 72.5523 76.5 72 76.5C71.4477 76.5 71 76.0523 71 75.5C71 74.9477 71.4477 74.5 72 74.5C72.5523 74.5 73 74.9477 73 75.5ZM44 76.5C44.5523 76.5 45 76.0523 45 75.5C45 74.9477 44.5523 74.5 44 74.5C43.4477 74.5 43 74.9477 43 75.5C43 76.0523 43.4477 76.5 44 76.5ZM61 75.5C61 76.0523 60.5523 76.5 60 76.5C59.4477 76.5 59 76.0523 59 75.5C59 74.9477 59.4477 74.5 60 74.5C60.5523 74.5 61 74.9477 61 75.5ZM76 76.5C76.5523 76.5 77 76.0523 77 75.5C77 74.9477 76.5523 74.5 76 74.5C75.4477 74.5 75 74.9477 75 75.5C75 76.0523 75.4477 76.5 76 76.5ZM39 77C39 77.5523 38.5523 78 38 78C37.4477 78 37 77.5523 37 77C37 76.4477 37.4477 76 38 76C38.5523 76 39 76.4477 39 77ZM54 78C54.5523 78 55 77.5523 55 77C55 76.4477 54.5523 76 54 76C53.4477 76 53 76.4477 53 77C53 77.5523 53.4477 78 54 78ZM71 77C71 77.5523 70.5523 78 70 78C69.4477 78 69 77.5523 69 77C69 76.4477 69.4477 76 70 76C70.5523 76 71 76.4477 71 77ZM42 75C42.5523 75 43 74.5523 43 74C43 73.4477 42.5523 73 42 73C41.4477 73 41 73.4477 41 74C41 74.5523 41.4477 75 42 75ZM59 74C59 74.5523 58.5523 75 58 75C57.4477 75 57 74.5523 57 74C57 73.4477 57.4477 73 58 73C58.5523 73 59 73.4477 59 74ZM74 75C74.5523 75 75 74.5523 75 74C75 73.4477 74.5523 73 74 73C73.4477 73 73 73.4477 73 74C73 74.5523 73.4477 75 74 75ZM43 77C43 77.5523 42.5523 78 42 78C41.4477 78 41 77.5523 41 77C41 76.4477 41.4477 76 42 76C42.5523 76 43 76.4477 43 77ZM58 78C58.5523 78 59 77.5523 59 77C59 76.4477 58.5523 76 58 76C57.4477 76 57 76.4477 57 77C57 77.5523 57.4477 78 58 78ZM75 77C75 77.5523 74.5523 78 74 78C73.4477 78 73 77.5523 73 77C73 76.4477 73.4477 76 74 76C74.5523 76 75 76.4477 75 77ZM46 75C46.5523 75 47 74.5523 47 74C47 73.4477 46.5523 73 46 73C45.4477 73 45 73.4477 45 74C45 74.5523 45.4477 75 46 75ZM63 74C63 74.5523 62.5523 75 62 75C61.4477 75 61 74.5523 61 74C61 73.4477 61.4477 73 62 73C62.5523 73 63 73.4477 63 74ZM48 76.5C48.5523 76.5 49 76.0523 49 75.5C49 74.9477 48.5523 74.5 48 74.5C47.4477 74.5 47 74.9477 47 75.5C47 76.0523 47.4477 76.5 48 76.5ZM65 75.5C65 76.0523 64.5523 76.5 64 76.5C63.4477 76.5 63 76.0523 63 75.5C63 74.9477 63.4477 74.5 64 74.5C64.5523 74.5 65 74.9477 65 75.5ZM52 76.5C52.5523 76.5 53 76.0523 53 75.5C53 74.9477 52.5523 74.5 52 74.5C51.4477 74.5 51 74.9477 51 75.5C51 76.0523 51.4477 76.5 52 76.5ZM69 75.5C69 76.0523 68.5523 76.5 68 76.5C67.4477 76.5 67 76.0523 67 75.5C67 74.9477 67.4477 74.5 68 74.5C68.5523 74.5 69 74.9477 69 75.5ZM46 78C46.5523 78 47 77.5523 47 77C47 76.4477 46.5523 76 46 76C45.4477 76 45 76.4477 45 77C45 77.5523 45.4477 78 46 78ZM63 77C63 77.5523 62.5523 78 62 78C61.4477 78 61 77.5523 61 77C61 76.4477 61.4477 76 62 76C62.5523 76 63 76.4477 63 77ZM50 75C50.5523 75 51 74.5523 51 74C51 73.4477 50.5523 73 50 73C49.4477 73 49 73.4477 49 74C49 74.5523 49.4477 75 50 75ZM67 74C67 74.5523 66.5523 75 66 75C65.4477 75 65 74.5523 65 74C65 73.4477 65.4477 73 66 73C66.5523 73 67 73.4477 67 74ZM50 78C50.5523 78 51 77.5523 51 77C51 76.4477 50.5523 76 50 76C49.4477 76 49 76.4477 49 77C49 77.5523 49.4477 78 50 78ZM67 77C67 77.5523 66.5523 78 66 78C65.4477 78 65 77.5523 65 77C65 76.4477 65.4477 76 66 76C66.5523 76 67 76.4477 67 77Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.5,
			y: 48.5,
			width: 12,
			height: 7,
			rx: .5,
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 55.5,
			y: 52.5,
			width: 12,
			height: 4,
			rx: .5,
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 45C36.5 44.7239 36.7239 44.5 37 44.5H40C40.2761 44.5 40.5 44.7239 40.5 45V48.5H36.5V45Z",
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.5 49C59.5 48.7239 59.7239 48.5 60 48.5H63C63.2761 48.5 63.5 48.7239 63.5 49V52.5H59.5V49Z",
			fill: "white",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 37.5,
			y: 21.5,
			width: 2,
			height: 23,
			fill: "#D9D9D9",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60.5,
			y: 25.5,
			width: 2,
			height: 23,
			fill: "#D9D9D9",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5 20.5H56.5V36.7427L50 41.3855L43.5 36.7427V20.5Z",
			fill: "white",
			stroke: "currentColor"
		})
	]
});
export default SvgLegacyPointFeedPreBake;
